import type { DeskEvent } from './events';

/** Saves the unsynced events as a JSON file, so they can be re-entered by
 * hand if the receptionist chooses to discard them from this device. */
export function downloadEvents(events: DeskEvent[]): void {
  const blob = new Blob([JSON.stringify({ exportedAt: new Date().toISOString(), events }, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `namibiago-desk-unsynced-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
